import { useMemo } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { canInviteMembers } from '../utils/teamPermissions';
import { usePendingRequests } from './useTeamRequests';
import { useUserTeam } from './useUserTeam';

/**
 * Pending join requests for the signed-in user's team, only when they are
 * owner/admin (the roles that can accept/refuse).
 */
export function useAdminPendingJoinRequests() {
  const { user } = useAuth();
  const { team, loading: teamLoading } = useUserTeam(user?.teamId);

  const canManage = useMemo(() => {
    if (!user || !team) return false;
    const role = team.members.find((m) => m.uid === user.uid)?.role;
    return canInviteMembers(role);
  }, [user, team]);

  const teamId = canManage ? team?.id : null;
  const { requests, loading: requestsLoading } = usePendingRequests(teamId);

  return {
    count: canManage ? requests.length : 0,
    requests: canManage ? requests : [],
    loading: Boolean(user?.teamId) && (teamLoading || (canManage && requestsLoading)),
    canManage,
    teamId: team?.id ?? null,
    teamSlug: team?.slug ?? null,
    teamName: team?.name ?? null,
  };
}
